import DocumentsTab from "../components/DocumentsTab";
import EventsTab from "../components/EventsTab";
import ResumeTab from "../components/ResumeTab";
import SupplyAuthorizationsTab from "../components/SupplyAuthorizationsTab";

export const billingBillTabs = ({
  needSupplyAuthorization,
}: {
  needSupplyAuthorization?: boolean
}) => [
  {
    label: 'Resumo',
    value: '',
    body: <ResumeTab />,
  },
  {
    label: 'Nota fiscal / Cobranças',
    value: 'documents',
    body: <DocumentsTab />,
  },
  {
    label: 'Transações',
    value: 'events',
    body: <EventsTab />,
  },
  {
    label: 'AFs',
    value: 'supply-authorizations',
    body: <SupplyAuthorizationsTab />,
    hidden: !needSupplyAuthorization,
  },
];
